import { render, staticRenderFns } from "./Centre.vue?vue&type=template&id=096ed98b&scoped=true&"
import script from "./Centre.vue?vue&type=script&lang=js&"
export * from "./Centre.vue?vue&type=script&lang=js&"
import style0 from "./Centre.vue?vue&type=style&index=0&id=096ed98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ed98b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VContainer,VRow,VSnackbar})
